import { render, staticRenderFns } from "./ClassicCases.vue?vue&type=template&id=08bc5a16&"
import script from "./ClassicCases.vue?vue&type=script&lang=js&"
export * from "./ClassicCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports